import type { ServiceCardItem } from "@components/ServiceCardItem.js";
import brackets from "@core/assets/icons/brackets.svg?raw";
import digi from "@core/assets/icons/digi.svg?raw";
import integration from "@core/assets/icons/integration.svg?raw";
import pc from "@core/assets/icons/pc.svg?raw";
import rentIt from "@core/assets/icons/rent-it.svg?raw";
import rescue from "@core/assets/icons/rescue.svg?raw";
import type { Tenant } from "@core/schema/Tenant.js";
import { getCloudSolutionsPath } from "@core/schema/paths/getCloudSolutionsPath.js";
import { getCrmPath } from "@core/schema/paths/getCrmPath.js";
import { getEmbeddedSoftwarePath } from "@core/schema/paths/getEmbeddedSoftwarePath.js";
import { getProjectRescuePath } from "@core/schema/paths/getProjectRescuePath.js";
import { getWebAppsPath } from "@core/schema/paths/getWebAppsPath.js";

export function getServicesToHire(tenant: Tenant): ServiceCardItem[] {
	return [
		{
			title: "Webové aplikace",
			iconName: brackets,
			show: true,
			href: getWebAppsPath(tenant),
		},
		{
			title: "Mobilní aplikace",
			iconName: rentIt,
			href: "#",
			show: false,
		},
		{
			title: "IT konzultace",
			iconName: rescue,
			href: "#",
			show: false,
		},
		{
			title: "Záchrana projektu",
			iconName: pc,
			show: true,
			href: getProjectRescuePath(tenant),
		},
		{
			title: "Vývoj cloudových řešení",
			iconName: digi,
			show: true,
			href: getCloudSolutionsPath(tenant),
		},
		{
			title: "Vývoj embedded software",
			iconName: integration,
			show: false,
			href: getEmbeddedSoftwarePath(tenant),
		},
		{
			title: "CRM",
			iconName: integration,
			show: true,
			href: getCrmPath(tenant),
		},
	];
}
